<router-outlet></router-outlet>
<ng-progress id="progressbar" aria-hidden="true"></ng-progress>
